module.exports = __webpack_public_path__ + "img/EG.1e3b6893.png";